module.exports = __webpack_public_path__ + "static/media/consultorio-06.686e3435.JPG";